// Packages
import { useState, useEffect } from "react";
import { Multiselect } from "multiselect-react-dropdown";
import toast from "react-hot-toast";
// Styles
import Styles from "./Styles/EditProfile.module.css";
// Images
import closeIcon from "../../../Assets/Icons/close.png";
// Components
import Input from "../../Common/Inputs/Input";
// API
import { editProfile, getUserData } from "../../../Services/usersService";

const EditProfile = ({ handleEditProfile }) => {
  const [info, setInfo] = useState({
    fullname: "",
    education: "",
    interestAreas: [],
    phoneNumber: "",
    email: "",
  });

  const [selectedData, setSelectedData] = useState([{ area: "" }]);

  const data = [
    { area: "آموزش پیش دبستانی و دبستانی" },
    { area: "مدیریت و برنامه ریزی آموزشی" },
    { area: "برنامه ریزی آموزشی" },
    { area: "آموزش و پرورش تطبیقی" },
    { area: "برنامه ریزی درسی" },
    { area: "تحقیقات آموزشی" },
    { area: "آموزش و پرورش استثنایی" },
    { area: "روانشناسی تربیتی" },
    { area: "آموزش بزرگسالان" },
    { area: "مشاوره و راهنمایی" },
    { area: "آموزش و بهسازی منابع انسانی" },
    { area: "تاریخ و فلسفه تعلیم و تربیت" },
    { area: "تکنولوژی آموزشی" },
    { area: "مدیریت و برنامه ریزی آموزش عالی" },
    { area: "سنجش و اندازه گیری در آموزش و پرورش" },
    { area: "برنامه ریزی توسعه آموزش عالی" },
    { area: "برنامه ریزی درسی در آموزش عالی" },
    { area: "مدیریت آموزش عالی" },
    { area: "اقتصاد آموزش عالی" },
    { area: "یادگیری مادام العمر" },
    { area: "تئوری های یادگیری" },
    { area: "طراحی ابزار و ملزومات کمک آموزشی" },
    { area: "کسب و کار آموزشی" },
    { area: "اقتصاد آموزش و پرورش" },
    { area: "جریان پژوهی آموزشی و تربیتی" },
    { area: "آموزش عصب شناختی" },
    { area: "تجربه کاوی مدارس پیشرو و برتر" },
    { area: "سیاست گذاری آموزشی" },
    { area: "طراحی فضاهای یادگیری" },
    { area: "بهسازی زیست آموزشی " },
    { area: "سرگرمی پژوهی و بازی وارسازی" },
    { area: "پژوهش های اماری و کمی" },
    { area: "فلسفه ذهن" },
    { area: "مدل سازی شناختی" },
    { area: "زبان شناختی" },
    { area: "علوم اعصاب شناختی" },
    { area: "روان شناسی اختلالات یادگیری" },
    { area: "روانشناسی بالینی" },
    { area: "روانشناسی رشد و شناخت" },
    { area: "آگاهی پژوهی" },
    { area: "کتاب کودک و نوجوان" },
    { area: "الگو های مدرسه داری" },
    { area: "جامعه شناسی آموزش و پرورش" },
    { area: "پداگوژی" },
    { area: "تعلیم و تربیت باستان" },
    { area: "روش های تدریس" },
    { area: "اندیشمند پژوهی" },
    { area: "حکمرانی آموزشی" },
    { area: "منبع پژوهی آموزشی و تربیتی" },
    { area: "نظام های آموزشی" },
    { area: "فراشناخت کاربردی" },
    { area: "مفاهیم و نظریات آموزشی " },
    { area: "نهاد و سازمان پژوهی" },
    { area: "عدالت آموزشی" },
    { area: "فلسفه برای کودکان" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = await getUserData();
        setInfo(userData.data.user);
        setSelectedData(userData.data.user.interestAreas);
      } catch (ex) {
        toast.error(ex.response.data.message);
      }
    };
    fetchData();
  }, []);

  const handleInput = (event) => {
    const newInfo = { ...info };
    newInfo[event.target.name] = event.target.value;
    setInfo(newInfo);
  };
  const handleSendInfo = async (e) => {
    e.preventDefault();
    try {
      const userData = { ...info };
      userData.interestAreas = selectedData;
      await editProfile(userData);
      toast.success("اطلاعات شما با موفقیت بروزرسانی شد");
    } catch (ex) {
      toast.error(ex.response.data.message);
    }
  };

  return (
    <div className={Styles.container}>
      <div className={Styles.bluredContainer} onClick={handleEditProfile}></div>
      <div className={Styles.infoContainer}>
        <div className={Styles.hideContainer}>
          <div className={Styles.closeIcon} onClick={handleEditProfile}>
            <img src={closeIcon} alt="" />
          </div>
        </div>
        <div className={Styles.inputsContainer}>
          <div className={Styles.multiInput}>
            <Input
              name="fullname"
              placeholder="نام و نام خانوادگی"
              type="text"
              onChange={handleInput}
              value={info.fullname}
              halfWidth={true}
            />
            <Input
              name="email"
              placeholder="ایمیل"
              type="email"
              onChange={handleInput}
              value={info.email}
              halfWidth={true}
            />
          </div>
          <div className={Styles.input}>
            <Input
              name="phoneNumber"
              placeholder="شماره تماس"
              type="tel"
              onChange={handleInput}
              value={info.phoneNumber}
            />
          </div>
          <div className={Styles.input}>
            <Multiselect
              selectionLimit={5}
              options={data}
              displayValue="area"
              closeIcon="circle"
              placeholder="انتخاب"
              className={Styles.multiSelectContainer}
              onSelect={(val) => setSelectedData(val)}
              onRemove={(val) => setSelectedData(val)}
              selectedValues={selectedData}
              style={{
                chips: { background: "#4b495b" },
                searchBox: {
                  background: "#ACABB4",
                  border: "none",
                  direction: "rtl",
                },
              }}
            />
          </div>
          <div className={Styles.input}>
            <select
              value={info.education}
              name="education"
              id="education"
              onChange={handleInput}
            >
              <option value="high school">زیر دیپلم</option>
              <option value="diploma">دیپلم</option>
              <option value="associate">کاردانی</option>
              <option value="masters">کارشناسی</option>
              <option value="senior">کارشناسی ارشد</option>
              <option value="phd">دکترا</option>
            </select>
          </div>
          <button onClick={handleSendInfo}>بروزرسانی پروفایل</button>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
